// extracted by mini-css-extract-plugin
export default {"flexed":"styles_flexed__eu34g","label":"styles_label__VsEh9 styles_flexed__eu34g"};